import { render, staticRenderFns } from "./MultiOptionAdd.vue?vue&type=template&id=be45fd64"
import script from "./MultiOptionAdd.vue?vue&type=script&lang=js"
export * from "./MultiOptionAdd.vue?vue&type=script&lang=js"
import style0 from "./MultiOptionAdd.vue?vue&type=style&index=0&id=be45fd64&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports